import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery'
import utils from '../../utils'
import store from '../../store'
import http from '../../axios'
import network from '../../constant'

// jQuery
const jquery = window.jQuery || $
window.jQuery = jquery
window.$ = jquery

const loadScript = src => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = src
  script.onload = resolve
  script.onerror = reject
  document.body.appendChild(script)
})

const initLegacyScripts = async () => {
  const baseUrl = process.env.BASE_URL || '/'

  await loadScript(`${baseUrl}js/jquery.placeholder.js`)
  await loadScript(`${baseUrl}js/script.js`)
  await loadScript(`${baseUrl}js/verification.js?d=180116`)
  await loadScript(`${baseUrl}js/fancybox/jquery.fancybox.js`)
  await loadScript(`${baseUrl}js/scrollreveal.js`)
  await loadScript(`${baseUrl}js/nicescroll/jquery.nicescroll.js`)

  jquery(function () {
    localStorage.clear()
    jquery('input, textarea').placeholder()

    jquery('.fancybox').fancybox({
      padding: 0,
      closeBtn: false,

      helpers: {
        overlay: {
          locked: true
        }
      }
    })
  })
}

const app = createApp(App)

app.config.globalProperties.$utils = utils
app.config.globalProperties.$network = network
app.config.globalProperties.$http = http

app.use(store)
app.use(router)

app.mount('#app')

initLegacyScripts()

